import { defineComponent as _defineComponent } from 'vue'

    const __default__ = {
        model: {
            prop: 'modelValue',
            event: 'update:modelValue',
        },
    };

import { useViewport } from '@travelata-libs/utils';
    import { computed, unref, watch } from 'vue';
    import CheckBoxInput from '@ve/components/inputs/CheckBoxInput.vue';
    import TextCommon from '@ve/components/inputs/TextCommon.vue';
    import { useOperatorFilterModel } from '@features/operator/filterByOperator';
    import { BONUS_MILES_OPERATORS, BONUS_MILES_TEXT } from '../../lib/filterByBonusMiles';
    import BonusMilesBadge from './BonusMilesBadge.vue';

    enum BonusMilesFilterVariant {
        Filter = 'filter',
        Checkbox = 'checkBox',
    }

    interface BonusMilesFilterProps {
        modelValue: boolean;
        isHovered?: boolean;
        variant?: `${BonusMilesFilterVariant}`;
    }

    interface BonusMilesFilterEmits {
        (e: 'update:modelValue', value: boolean): void;
    }

    
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'BonusMilesFilter',
  props: {
    modelValue: { type: Boolean },
    isHovered: { type: Boolean, default: false },
    variant: { default: 'filter' }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
        (e: 'update:modelValue', value: boolean): void;
    }), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: boolean, isHovered: boolean, variant: `${BonusMilesFilterVariant}` }

    

    

    const { isMobile } = useViewport();
    const { takenOperators: selectedOperators } = useOperatorFilterModel();

    const isSelected = computed({
        get: () => props.modelValue,
        set: (v: boolean) => emit('update:modelValue', v),
    });

    const badgeOptions = computed(() => {
        return props.variant === BonusMilesFilterVariant.Filter
            ? {
                  iconVariant: 'green',
              }
            : {
                  iconVariant: 'none',
                  tooltipIcon: 'airplane',
              };
    });

    const isDisabled = computed(() => {
        const operators = unref(selectedOperators);
        return operators?.length > 0 && operators.some((operatorId) => !BONUS_MILES_OPERATORS.has(operatorId));
    });

    watch(isDisabled, (value) => {
        if (value) emit('update:modelValue', false);
    });

return { __sfc: true,BonusMilesFilterVariant, props, emit, isMobile, selectedOperators, isSelected, badgeOptions, isDisabled, CheckBoxInput, TextCommon, BONUS_MILES_TEXT, BonusMilesBadge }
}

})